module.exports = __webpack_public_path__ + "static/494a0cfb049499efc465441eb45d276132c4cd7451277625e3343a8313b68ce6-8a86db126c970dea74e5a1de83361d6c.jpeg";